import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ClientListComponent = React.lazy(() => import("../../../components/clients/components/list/page"));
const ClientAddComponent = React.lazy(() => import("../../../components/clients/components/add/create"));

const ClientsUsageListComponent = React.lazy(() => import("../../../components/clients-usage/components/list/page"));

export const clientRoute = [
    {
        path: 'list',
        element: <ClientListComponent />
    },
    {
        path: 'usage',
        element: <ClientsUsageListComponent />
    },
    {
        path: 'add',
        element: <ClientAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/clients/add" />
    },
    {
        path: 'edit/:id',
        element: <ClientAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/clients/list" />
    },
];